let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("b8qk9")).then(() => parcelRequire('3ANMU'));